export default function TermsBody({ shop }) {
  const sections = shop?.terms ?? [];
  if (!sections.length && shop?.terms_text) {
    return <p className="whitespace-pre-line text-sm text-foreground/80">{shop.terms_text}</p>;
  }
  return (
    <div className="space-y-4" data-testid="terms-body">
      {sections.map((sec, i) => (
        <div key={i}>
          <h3 className="font-display text-sm font-bold">{sec.title}</h3>
          <ul className="mt-1 list-disc space-y-1 pl-5 text-sm text-foreground/80">
            {sec.points.map((p, j) => (
              <li key={j}>{p}</li>
            ))}
          </ul>
        </div>
      ))}
      {!sections.length ? <p className="text-sm text-muted-foreground">Terms will appear here.</p> : null}
    </div>
  );
}
